import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  virtualListUnfoldCacheId: number;
  overviewCacheData: any;
  labelsCacheData: any[];
}

const initialState: InitStata = {
  virtualListUnfoldCacheId: 0, // 缓存虚拟列表展开项的id
  labelsCacheData: [], // 缓存虚拟列表展开项relations接口数据，避免因为组件render造成的闪动
  overviewCacheData: null, // 缓存虚拟列表展开项overview接口数据，避免因为组件render造成的闪动
};

const customerSlice = createSlice({
  name: 'iterate',
  initialState,
  reducers: {
    setVirtualListUnfoldCacheId: (state = initialState, action: PayloadAction<number>) => {
      state.virtualListUnfoldCacheId = action.payload;
    },
    setLabelsCacheData: (state = initialState, action: PayloadAction<any[]>) => {
      state.labelsCacheData	 = action.payload;
    },
    setOverviewCacheData: (state = initialState, action: PayloadAction<any>) => {
      state.overviewCacheData	 = action.payload;
    },
    clearCacheData: (state = initialState) => {
      state.labelsCacheData	 = [];
      state.overviewCacheData	 = null;
    },
  },
});

// 导出action
export const {
  setVirtualListUnfoldCacheId,
  setLabelsCacheData,
  setOverviewCacheData,
  clearCacheData,
} = customerSlice.actions;

export default customerSlice.reducer;
